<template>
  <modal
      ref="modal"
      large
      title="Offer Review"
      :onClose="closing"
      :no-scroll="mode === 'Notes'"
      height="480px">
    <template #buttons v-if="$listeners.done">
      <b-button variant="link" class="text-white d-none d-sm-inline" size="sm" @click="$emit('done')">BACK
      </b-button>
    </template>
    <template #top>
      <template v-if="!!offer">
        <div class="d-flex mb-0">
          <div class="mb-auto mr-auto h5">
            <text-copy>{{ offer.gli }}</text-copy>
          </div>

          <div>
            <div class="d-block text-right">
              <span class="h5">{{ offer.quantity }} @ </span><span
                class="h5">{{
                offer.offer_amount_native | money(offer.currency)
              }}</span><span
                class="text-muted pl-1"> {{ offer.currency }}</span>
              <div v-if="!offer.is_native_currency">Approx {{ offer.offer_amount | money }} USD</div>
            </div>
          </div>
        </div>
        <template v-if="!!offer.auction">
          <div class="text-muted mt-2">{{ offer.auction.eb_Title }}</div>
        </template>

        <mode-selector breakpoint="md" class="mt-3" v-if="!!offer && !action && modes && (modes.length > 1)"
                       v-model="mode"
                       :modes="modes"/>

      </template>
    </template>

    <template v-if="!!offer">
      <offer-action @done="done" @cancel="action = null" :offer="offer" :action="action"
                    v-if="!!action"/>

      <template v-else>
        <div class="mx-4" v-if="mode === 'Appraisal'">
          <!--<auction-research no-title no-modal :item="offer.item"/>-->
          <research-modal embed :value="offer.auction.research"/>
        </div>

        <template v-if="mode === 'Pricing'">

          <modal-portal to="subtop">
            <chip-selector :items="['Listing Reprice', 'Orders', 'Sold Prices']" v-model="price_type" class="-2"/>
          </modal-portal>

          <template v-if="!!offer.auction && price_type === 'Listing Reprice'">
            <auction-price-log :auction="offer.auction"/>
          </template>

          <div class="px-2" v-if="price_type === 'Sold Prices'">
            <report-table responsive nosum :id="12"
                          :hide_cols="['SKU', 'Description', 'Model', 'Part', 'Mean Time (Days)']"
                          :form="{sku: offer.item.id}"/>
          </div>

          <auction-sales-list v-if="price_type === 'Orders'" :summary="offer.order_summary"/>
        </template>

        <template v-if="mode === 'History'">
          <modal-portal to="subtop">
            <chip-selector :items="[{text:'From User', value: 'related'}, {text: 'All', value: 'all'}]"
                           v-model="hist"/>
          </modal-portal>
          <offer-history v-if="mode === 'History'" :offers="offer.history[hist]"/>
        </template>

        <div v-if="mode ==='Automation'" class="mx-5">
          <auction-automation readonly :value="offer.auction.rules" :completed="offer.auction.rules_executed"
                              :price="offer.auction.price"/>
        </div>

        <div class="p-2" v-if="mode == 'General'">
          <b-alert show v-if="offer.weboffer_outofmarket" dismissible variant="danger">Buyer country not in available in
            Shopify market.
          </b-alert>

          <b-alert class="mb-3" variant="warning" :show="!!alerts.length" dismissible>
            <div v-for="alert in alerts" :key="alert.id" v-text="alert.note"/>
          </b-alert>

          <template v-if="offer.weboffer_accept">
            <b-alert class="mb-3 d-flex flex-row" variant="info" show>
              <div class="flex-fill my-auto">

                <li v-if="!!offer.weboffer_accept.shopify_draft_order">
                  Draft order
                  <b-link :href="offer.weboffer_accept.shopify_draft_order.invoice_url">
                    {{ offer.weboffer_accept.shopify_draft_order.name }}
                  </b-link>
                  is {{
                    offer.weboffer_accept.shopify_draft_order.deleted_at ? 'deleted' : offer.weboffer_accept.shopify_draft_order.status
                  }}.
                </li>
                <li v-else>No draft order created.</li>

                <li v-if="!!offer.weboffer_accept.order">
                  Order
                  <b-link :href="'/order/' + offer.weboffer_accept.order.id">{{
                      offer.weboffer_accept.order.gli
                    }}
                  </b-link>
                  is {{ offer.weboffer_accept.order.status_desc }}.
                </li>
                <li v-else>No order created.</li>
              </div>

              <div class="my-auto">
                <b-dropdown variant="link" no-caret size="lg" v-if="Object.keys(offer.weboffer_accept._links).length">
                  <template #button-content>
                    <font-awesome-icon icon="fa-solid fa-ellipsis-v"/>
                  </template>

                  <b-dropdown-item @click="createOrder" v-if="!!offer.weboffer_accept._links.order_create_url">Create
                    Order
                  </b-dropdown-item>
                  <b-dropdown-item @click="createDraft" v-if="!!offer.weboffer_accept._links.draft_create_url">Create
                    Draft
                  </b-dropdown-item>
                  <b-dropdown-item @click="deleteDraft" v-if="!!offer.weboffer_accept._links.draft_delete_url">Delete
                    Draft
                  </b-dropdown-item>

                </b-dropdown>
              </div>
            </b-alert>
          </template>

          <auction-status v-else-if="!!offer.auction" :auction="offer.auction" @offers="mode='History'"
                          @sales="mode='Pricing'"/>

          <b-alert v-if="offer.internal_note" variant="warning" v-text="offer.internal_note" show/>

          <b-alert v-if="offer.state == 'P' && last" variant="secondary" show class="mt-3">
            Last counter offer of {{ last.quantity }} @
            {{ last.offer_amount_native | money(last.currency) }}
            {{ last.result_at | timediff }} by {{ last.from }}
          </b-alert>

          <div class="mx-auto">
            <modal-row is-text v-if="!!offer.customer" label="Customer">
              {{ offer.customer.model_description }}
            </modal-row>

            <modal-row is-text label="Origination">
              {{ offer.source_description }}
              <span v-if="offer.auction">
            (<a :href="'/auction/' + offer.auction.id" target="_blank">{{ offer.auction.gli }}</a>)
          </span>
            </modal-row>

            <modal-row is-text v-if="!!offer.item" label="Weight & Dims">
              {{ offer.item.weight || '?' }} Lbs
              <div>{{ offer.item.dim_length || '?' }}" x {{ offer.item.dim_width || '?' }}" x {{
                  offer.item.dim_height || '?'
                }}"
              </div>
            </modal-row>

            <form-create-info :value="offer" no-divider/>

            <modal-row is-text label="Expires" v-if="offer.needs_seller_action">
              {{ offer.expire_time | date }}
            </modal-row>

            <modal-row is-text v-if="offer.status == 'D'" label="Discount">
              {{ offer.result_description }} by {{ offer.result_by_user.userid }} at {{ offer.result_at | date }}
            </modal-row>

            <modal-row is-text v-if="!!offer.auction" label="Discount">
              {{ offer.discount }}% off {{ offer.auction.eb_CurrentPrice  | money }} USD
            </modal-row>

            <modal-row is-text label="Location">
              {{ offer.state }} {{ offer.zip }}<br>{{ offer.country_long }} ({{ offer.country }})
            </modal-row>

            <modal-row is-text v-if="offer.buyer_message" label="Buyer Msg">
              {{ offer.buyer_message }}
            </modal-row>

            <modal-row is-text v-if="offer.seller_message" label="Seller Msg">
              {{ offer.seller_message }}
            </modal-row>

            <modal-row is-text v-if="offer.source === 'E'" label="User ID">
              {{ offer.eb_Buyer_UserID }}
            </modal-row>

            <modal-row is-text v-if="!!offer.email" label="Email">
              {{ offer.email }}
            </modal-row>

            <modal-row is-text v-if="offer.source === 'W'" label="Store URL">
              <a target="_blank" :href="offer.auction.shopify_product_url + '?' + offer.download_key">Link</a>
            </modal-row>
          </div>
        </div>

        <div class="p-2" v-else-if="mode === 'Photos'">
          <photo-gallery v-if="!!offer.auction" :photos="offer.auction.photos" readonly/>
        </div>

        <div v-show="mode === 'notes'">
          <notes v-if="offer && offer.auction && can('auctions.notes.read')"
                 @refresh="(n) => offer.auction.notes = n" height="auto" write="auctions.notes.write"
                 :in-modal="mode === 'notes'" :url="offer.auction._links.self_url.href + '/note'"/>
        </div>

      </template>
    </template>

    <template #footer v-if="!action">
      <template v-if="!!offer">
        <template v-if="offer.auction">
          <b-btn v-if="mode == 'Appraisal'" size="sm" variant="outline-primary" @click="asyncAction(offer.auction._links.self_url.href, 'PUT', {data: {task: 'research'}}).then(() => refresh())" class="px-3 mr-3">Appraise</b-btn>
          <research-menu large :value="(offer.auction.item.manuf || '') + ' ' + (offer.auction.item.modelno || '')" class="mr-3" />
        </template>

        <template v-if="offer.needs_seller_action">
          <b-btn variant="secondary" @click="action = 'counter'" size="sm" class="px-3 mr-1">
            Counter
          </b-btn>
          <b-btn variant="danger" @click="action = 'decline'" size="sm" class="px-3 mr-1">
            Decline
          </b-btn>
          <b-btn variant="success" @click="action = 'accept'" size="sm" class="px-3">
            Accept
          </b-btn>
        </template>
      </template>
    </template>
  </modal>
</template>

<script>
import AuctionResearch from "../auction/auction-research.vue"
import AuctionStatus from '../auction/auction-status.vue'
import OfferHistory from "./offer-history.vue";
import AuctionSalesList from "../auction/auction-sales-list.vue";
import OfferAction from "./offer-action.vue";
import AuctionPriceLog from "../auction/auction-price-log.vue";
import AuctionAutomation from "../auction/auction-automation.vue";
import ReportTable from "@/components/report/report-table.vue";
import FormCreateInfo from "@/components/form/form-create-info.vue";
import ResearchModal from "@/components/research/research-modal.vue";
import ResearchMenu from "@/components/layout/research-menu.vue";

export default {
  name: "offer",

  components: {
    ResearchMenu,
    ResearchModal,
    FormCreateInfo,
    ReportTable,
    AuctionAutomation,
    AuctionPriceLog,
    OfferAction,
    AuctionSalesList,
    OfferHistory,
    AuctionResearch,
    AuctionStatus
  },

  props: {
    url: String,
  },

  data() {
    return {
      offer: null,
      mode: 'General',
      hist: 'related',
      action: null,
      price_type: 'Listing Reprice'
    }
  },

  mounted() {
    this.refresh()
  },

  computed: {
    alerts() {
      return this.offer && this.offer.auction ? this.offer.auction.notes.all.filter(n => n.offeralert) : []
    },

    last() {
      return this.offer.history.related && this.offer.history.related.find(h => {
        return ((h.originator == 'S') && (h.result == 'C'))
      })
    },

    pos() {
      if (!this.offer.auction)
        return []
      const po = this.offer.auction.inventory.map(f => f.po)

      return po.filter((value, index) => {
        return index === po.findIndex(o => o.id = value.id)
      })
    },

    modes() {
      const modes = [{text: 'General', value: 'General'}]

      if (this.offer.auction) {
        if (this.offer.item)
          modes.push(
              {text: 'Appraisal', value: 'Appraisal'}, {text: 'Pricing', value: 'Pricing'},
              {
                text: 'Automation (' + (this.offer.auction.rules ? this.offer.auction.rules.length : 0) + ')',
                value: 'Automation'
              },
          )

        modes.push(
            {text: 'Photos (' + this.offer.auction.photos.length + ')', value: 'Photos'},
            {text: 'History (' + this.offer.history.all.length + ')', value: 'History'},
            {text: 'Notes (' + this.offer.auction.notes.all.length + ')', value: 'Notes'}
        )
      }

      return modes
    }
  },

  methods: {
    closing() {
      this.$store.dispatch('badges_load')
      return true
    },

    done() {
      if (this.$listeners.done)
        this.$emit('done')
      else
        this.$refs.modal.close()
    },

    async refresh() {
      this.offer = await this.asyncAction(this.url + '?with[]=history', 'GET')
    },

    async deleteDraft() {
      if (await this.confirm('Delete draft order?')) {
        this.asyncAction(this.offer.weboffer_accept._links.draft_delete_url.href, this.offer.weboffer_accept._links.draft_delete_url.method).then(() => {
          this.refresh()
        })
      }
    },

    async createDraft() {
      if (await this.confirm('Create draft order?')) {
        this.asyncAction(this.offer.weboffer_accept._links.draft_create_url.href, this.offer.weboffer_accept._links.draft_create_url.method).then(() => {
          this.refresh()
        })
      }
    },

    async createOrder() {
      if (await this.confirm('Delete draft order and create direct order for this offer?')) {
        this.asyncAction(this.offer.weboffer_accept._links.order_create_url.href, this.offer.weboffer_accept._links.order_create_url.method).then(({id}) => {
          window.location.href = '/order/' + id
        })
      }
    }
  }
}
</script>

<style scoped>
.offer-width {
  max-width: 400px;
}
</style>